import React, { useRef, useEffect, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import AvisoLegal from "./AvisoLegal";
import PoliticaPrivacidad from "./PoliticaPrivacidad";
import { SpinnerContext } from "../../context/spinnerContext";
import { swalPopUp } from "../../utils/swal";
import "../../styles/site-footer/footer.css";


const Footer = () => {
    const myModalAvisoRef = useRef(null);
    // const myModalPoliticaRef = useRef(null);
    const myInputRef = useRef(null);
    const [showBackToTop, setShowBackToTop] = useState(false);
    const [vefiClosed, setVefiClosed] = useState(false);

    useEffect(() => {
        const handleClosed = () => setVefiClosed(true);
        const handleOpened = () => setVefiClosed(false);

        window.addEventListener('vefiMascotClosed', handleClosed);
        window.addEventListener('vefiMascotOpened', handleOpened);
        return () => {
            window.removeEventListener('vefiMascotClosed', handleClosed);
            window.removeEventListener('vefiMascotOpened', handleOpened);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowBackToTop(true);
            } else {
                setShowBackToTop(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const myModalAviso = myModalAvisoRef.current;
        const myInput = myInputRef.current;

        if (myModalAviso && myInput) {
            const handleModalShown = () => {
                myInput.focus();
            };

            myModalAviso.addEventListener("shown.bs.modal", handleModalShown);

            return () => {
                myModalAviso.removeEventListener("shown.bs.modal", handleModalShown);
            };
        }
    }, []);

    /***************************** Formulario de contacto ************************************/

    const { showSpinner } = useContext(SpinnerContext);
    const formRef = useRef(null);
    const thisLocation = useLocation();

    // Rutas privadas donde el footer completo no se muestra (o es mínimo)
    const privateRoutes = [
        "/Dashboard", "/Perfil", "/MisEmpresas", "/admin",
        "/Favoritos", "/Informe", "/Calendario"
    ];
    const isPrivateRoute = privateRoutes.some(route => thisLocation.pathname.toLowerCase().startsWith(route.toLowerCase()));

    if (isPrivateRoute) {
        return null; // En un SaaS puro, el footer lateral/inferior suele omitirse para ganar espacio.
    }

    const validateForm = async () => {
        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData);
        const formValues = Object.values(data);

        if (formValues.every((input) => input.trim() !== "")) {
            sendContactForm();
        } else {
            swalPopUp("Ops!", "Debes ingresar un e-mail", "warning");
        }
    };

    const sendContactForm = async () => {
        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData);

        try {
            showSpinner(true);
            const respJSON = await fetch("/sendNewsLetterMail.php", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const respOBJ = await respJSON.json();
            showSpinner(false);
            if (respOBJ.msg.includes("Error")) {
                swalPopUp("Ops!", `${respOBJ.msg}, Intente otra vez`, "error");
            } else {
                const inputs = document.querySelectorAll(".inputForm");
                inputs.forEach((input) => (input.value = ""));
                swalPopUp(
                    "Suscripción exitosa",
                    "Gracias por suscribirte!",
                    "success"
                );
                const contactInputs = document.querySelectorAll(".contactInput");
                contactInputs.forEach((input) => (input.value = ""));
            }
        } catch (err) {
            showSpinner(false);
            swalPopUp(
                "Ops!",
                err instanceof Error
                    ? `Error al enviar el mensaje: ${err.message}`
                    : "Error al enviar el mensaje: problema desconocido",
                "error"
            );
        }
    };


    return (
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <Link to="/">
                            <img
                                src="/images/logos/logo-vefrek-white.png"
                                alt="Vefrek"
                                className="vefrek-logo-footer"
                            />
                        </Link>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-info">
                                <p className="mt-3">
                                    <strong>Email:</strong> administracion@vefrek.com.ar
                                    <br />
                                </p>
                                <div className="social-links mt-3">
                                    <a
                                        href="https://www.facebook.com/vefrek?mibextid=ZbWKwL"
                                        className="facebook"
                                    >
                                        <i className="bx bxl-facebook"></i>
                                    </a>
                                    <a
                                        href="https://www.instagram.com/vefrek.oficial/?next=https%3A%2F%2Fwww.instagram.com%2F&hl=es-es"
                                        className="instagram"
                                    >
                                        <i className="bx bxl-instagram"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4 className="text-start">Links útiles</h4>
                            <ul>
                                <li>
                                    <i className="bx bx-chevron-right"></i>
                                    <HashLink smooth to="/#about">Nosotros</HashLink>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>
                                    <HashLink smooth to="/#contact">Contacto</HashLink>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>
                                    <a
                                        href="/"
                                        data-bs-toggle="modal"
                                        data-bs-target="#avisoLegalModal"
                                    >
                                        Aviso Legal
                                    </a>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>
                                    <a
                                        href="/"
                                        data-bs-toggle="modal"
                                        data-bs-target="#ModalPrivacidad"
                                    >
                                        Política de Privacidad
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4 className="text-start">Categorías</h4>
                            <ul>
                                <li>
                                    <Link to="/Reparacion">
                                        <i className="bx bx-chevron-right"></i> Talleres
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/Reparacion">
                                        <i className="bx bx-chevron-right"></i> Gomerías
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/Reparacion">
                                        <i className="bx bx-chevron-right"></i> Lubricentros
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/Reparacion">
                                        <i className="bx bx-chevron-right"></i> Repuestos
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/Venta">
                                        <i className="bx bx-chevron-right"></i> Concesionarias
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <form className="col-lg-4 col-md-6 footer-newsletter" ref={formRef}>
                            <h4>Suscríbete a nuestro Newsletter</h4>
                            <p>
                                Suscríbete para que te enviemos todas las noticias de nuestro
                                sitio
                            </p>
                            <input
                                type="email"
                                name="email"
                                className="form-control mt-3"
                                placeholder="Ingresa tu correo para suscribirte"
                            />
                            <button type="button" className="btn-news ml-2" onClick={validateForm}>
                                Suscribirse
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="copyright">
                    &copy; 2026 <strong>
                        <a href="https://francobiason.com.ar/" target="_blank" rel="noopener noreferrer">FBDev</a>
                    </strong>
                    . All Rights Reserved.
                </div>
            </div>

            {/* Componentes de modales */}
            <AvisoLegal />
            <PoliticaPrivacidad />

            <button className={`back-to-top-btn ${showBackToTop ? 'visible' : ''} ${vefiClosed ? 'vefi-closed' : ''}`} onClick={scrollToTop} aria-label="Volver arriba">
                <i className="bx bx-up-arrow-alt"></i>
            </button>
        </footer>
    );
};

export default Footer;
